





























import { Component, Vue } from 'vue-property-decorator'
import { LineGroup } from '../store/line'
import Edit from './Edit.vue'
import { namespace } from 'vuex-class'

const lineStore = namespace('line')

@Component({ components: { Edit } })
export default class MainLine extends Vue {
  @lineStore.Action getAll!: () => void
  @lineStore.Getter groups!: LineGroup[]
  created() {
    this.getAll()
  }
}
